const title = "Tổng đài đặt sân golf (wBooking)";

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    document.title = `${pageTitle} - ${title}`;
    return `${pageTitle} - ${title}`;
  }
  document.title = title;
  return title;
}
